import { type Theme } from "@mui/material";
import { type Components } from "@mui/material/styles";

import { getSafeAreaPaddings } from "../utils/getSafeAreaPaddings";

export const muiBottomNavigationOverrides: Components<Theme> = {
  MuiBottomNavigation: {
    styleOverrides: {
      root: ({ theme }) => ({
        marginTop: "auto",
        paddingTop: theme.spacing(5),
        ...getSafeAreaPaddings({
          bottom: true,
          left: true,
          right: true,
          fallbackBottom: theme.spacing(5),
          fallbackLeft: theme.spacing(7),
          fallbackRight: theme.spacing(7),
        }),
        justifyContent: "space-between",
        backgroundColor: theme.palette.background?.tertiary,
        // override MUI's default height
        height: "auto",
        boxShadow: theme.shadows[4],
      }),
    },
  },
  MuiBottomNavigationAction: {
    styleOverrides: {
      root: ({ theme }) => ({
        width: theme.size?.navbar.itemSize,
        maxWidth: theme.size?.navbar.itemSize,
        minWidth: "unset",
        height: theme.size?.navbar.itemSize,
        maxHeight: theme.size?.navbar.itemSize,
        minHeight: "unset",
        borderRadius: theme.borderRadius?.small,
        color: theme.palette.text?.tertiary,

        "&.Mui-selected": {
          color: theme.palette.text?.primary,
        },

        "& svg": {
          height: theme.size?.navbar.iconSize,
          width: theme.size?.navbar.iconSize,
        },
      }),

      label: ({ theme }) => ({
        fontSize: theme.size?.navbar.labelSize,
        lineHeight: 1.5,
        fontWeight: theme.typography.fontWeightMedium,
        marginTop: theme.spacing(1),

        "&.Mui-selected": {
          fontSize: theme.size?.navbar.labelSize,
        },
      }),
    },
  },
};
